/**
 * 系统管理 菜单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" label-position="right" label-width="100px" ref="formInlineRef"  :model="formInline" class="user-search">
      <el-form-item label="菜单名称：" prop="menuName">
        <el-input size="small" v-model="formInline.menuName" placeholder="请输入菜单名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" row-key="id"  style="width: 100%;">
      <el-table-column align="center"  prop="id" label="菜单编号" ></el-table-column>
      <el-table-column align="center"  prop="menuName" label="菜单名称" ></el-table-column>
      <el-table-column align="center"  prop="parentName" label="父菜单名称" ></el-table-column>
      <el-table-column align="center"  prop="level" label="菜单层级" ></el-table-column>
      <el-table-column align="center"  prop="path" label="菜单路径" ></el-table-column>
      <el-table-column align="center"  prop="sortNum" label="排序" ></el-table-column>
      <el-table-column align="center"  prop="createTime" label="创建时间" >
        <template slot-scope="scope">
          <div>{{scope.row.createTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="200px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteData(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
   <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>-->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%"  @click='closeDialog("edit")' :close-on-click-modal="false">
      <el-form label-width="120px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="上级菜单" prop="parentId">
          <el-select v-model="editForm.parentId" clearable placeholder="请选择" >
            <el-option
              v-for="item in sysMenuList"
              :key="item.id"
              :label="item.menuName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单名称" prop="menuName">
          <el-input size="small" v-model="editForm.menuName"  auto-complete="off" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="菜单路径" prop="path">
          <el-input size="small" v-model="editForm.path"  auto-complete="off" placeholder="请输入菜单路径"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" prop="icon">
          <el-input size="small" v-model="editForm.icon"  auto-complete="off" placeholder="请输入菜单图标"></el-input>
        </el-form-item>
        <el-form-item label="菜单排序" prop="sortNum">
          <el-input size="small" type="number" v-model="editForm.sortNum"  auto-complete="off" placeholder="请输入菜单排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import { qryMenuByRole } from '../../api/userMG'
import {qrySysMenuList,addSysMenu,upSysMenu,delSysMenu} from '../../api/sysApi'
import Pagination from '../../components/Pagination'
import {timestampToTime,parseTime} from "../../utils/util";
export default {
  data() {
    return {
      loading: false, //是显示加载
      title: '',
      editFormVisible: false, //控制编辑页面显示与隐藏
      times:'',
      // 编辑与添加
      editForm: {
        parentId: '',
        menuName: '',
        path: '',
        icon: '',
        sortNum:''
      },
      sysMenuList:[],
      // rules表单验证
      rules: {
        menuName: [
          { required: true, message: '菜单名称不能为空', trigger: 'blur' }
        ]
      },
      // 请求数据参数
      formInline: {
        menuName:''
      },
      //用户数据
      listData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    /**
     * @name: dataPicker
     * @Author: TJH
     * @msg: 时间选择器
     * @Date: 2021-02-25 14:47:12
     * @param value：[开始时间,结束时间]
     * @return {*}
     */
    dataPicker(value) {
      if (value != null) {
        console.log(value);
        this.formInline.beginTime = parseTime(
          value[0],
          "{y}-{m}-{d}"
        );
        this.formInline.endTime = parseTime(value[1], "{y}-{m}-{d}");
      } else {
        this.formInline.beginTime = "";
        this.formInline.endTime = "";
      }
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true;
      qryMenuByRole(parameter)
        .then(res => {
          this.loading = false
          if (res.code!=1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData=res.data;
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('系统异常，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.formInline.page=1
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.sysMenuList=[];
      if (row != undefined && row != 'undefined') {
        this.title = '修改菜单'
        this.editForm.id = row.id
        this.editForm.parentId = row.parentId
        this.editForm.menuName = row.menuName
        this.editForm.path = row.path
        this.editForm.icon = row.icon
        this.editForm.sortNum=row.sortNum
      } else {
        this.title = '新增菜单'
        this.editForm.id = ''
        this.editForm.parentId = '';
        this.editForm.menuName = '';
        this.editForm.path = '';
        this.editForm.icon = '';
        this.editForm.sortNum='';
      }
      qrySysMenuList({level:1})
        .then(res => {
          this.loading = false
          if (res.code!=1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.sysMenuList.push(...res.data);
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('系统异常，请稍后再试！')
        })
      this.editFormVisible = true
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upSysMenu(this.editForm).then(res =>{
              this.editFormVisible = false
              this.loading = false
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
          }else{
            addSysMenu(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code==1) {
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          }

          // 请求方法

        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      this.editFormVisible = false;
    },
    // 删除用户
    deleteData(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delSysMenu({id:row.id,parentId:row.parentId})
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已更新!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
/deep/ .el-input__prefix,
/deep/ .el-input__icon {
  line-height: 25px;
}
/deep/ .el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 23px;
  width: 5%;
  color: #303133;
}
</style>




// WEBPACK FOOTER //
// src/views/system/menu.vue